
import React, { useState, useRef, useEffect } from "react";
import "./fleet.css";
import Navbar from "../../../components/navbar/navbar";
import Footer from "../../../components/footer/Footer";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { fleetData } from "./fleetData";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io"; // Assuming these are available or can be replaced

// IMPORT YOUR ASSETS HERE
// import erjImg from "../../../assets/imgs/about-us/fleet/erj-190.svg";
// import b737700Img from "../../../assets/imgs/about-us/fleet/b737-700.svg";
import b737800Img from "../../../assets/imgs/about-us/fleet/fleet-plane.png";
// import b7878Img from "../../../assets/imgs/about-us/fleet/b787-8.svg";
// import b7879Img from "../../../assets/imgs/about-us/fleet/b787-9.svg";

// Mapping of images to IDs
const planeImages = {
  "erj-190": b737800Img,
  "b737-700": b737800Img,
  "b737-800": b737800Img,
  "b787-8": b737800Img,
  "b787-9": b737800Img,
};

const PlaneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3.5S19 4 17.5 5.5L14 9l-8.2-1.8L3 10l7.5 3L8 16l-3-1V18l2.5 1.5L9 21h3l-1-3 3-2.5 3 7.5 2.8-2.8z" />
  </svg>
);

const LocationIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const BoxIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

function Fleet() {
  const [activePlaneIndex, setActivePlaneIndex] = useState(2); // Default to B737-800 (index 2)
  const currentPlane = fleetData[activePlaneIndex];
  const timelineRef = useRef(null);

  const nextPlane = () => {
    setActivePlaneIndex((prev) => (prev + 1) % fleetData.length);
  };

  const prevPlane = () => {
    setActivePlaneIndex((prev) => (prev - 1 + fleetData.length) % fleetData.length);
  };

  // Auto-scroll the timeline to keep the active dot visible
  useEffect(() => {
    if (timelineRef.current) {
      const activeEl = timelineRef.current.querySelector('.timeline-point.active');
      if (activeEl) {
        const container = timelineRef.current;
        const scrollLeft = activeEl.offsetLeft - container.offsetWidth / 2 + activeEl.offsetWidth / 2;
        container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }
  }, [activePlaneIndex]);

  return (
    <div className="fleet-redesign-container animate__animated animate__fadeIn">
      <Navbar />
      <Breadcrumb />

      <header className="fleet-header">
        <div className="container-fluid px-md-5">
          <h1 className="animate__animated animate__slideInLeft">
            <PlaneIcon /> Flota
          </h1>
          <p className="animate__animated animate__slideInLeft animate__delay-1s">Conoce el avión perfecto para tu envío</p>
        </div>
      </header>

      <main className="fleet-main-content container-fluid px-md-5">

        {/* Main Display Area */}
        <section className="plane-display">
          <button className="nav-arrow prev" onClick={prevPlane} title="Anterior">
            <IoIosArrowBack size={24} />
          </button>

          <div className={`plane-info animate__animated animate__fadeInLeft active-${activePlaneIndex}`}>
            <h2>{currentPlane.model}</h2>
            <h3>{currentPlane.fullModel}</h3>
            <p className="range-tag">{currentPlane.category}</p>
          </div>

          <div className={`plane-image-container animate__animated animate__fadeInRight active-${activePlaneIndex}`}>
            {planeImages[currentPlane.id] ? (
              <img src={planeImages[currentPlane.id]} alt={currentPlane.model} key={currentPlane.id} className="plane-img animate__animated animate__zoomIn" />
            ) : (
              <div className="placeholder-image">
                <PlaneIcon />
                <p>Imagen {currentPlane.model}</p>
              </div>
            )}
          </div>

          <button className="nav-arrow next" onClick={nextPlane} title="Siguiente">
            <IoIosArrowForward size={24} />
          </button>
        </section>

        {/* Timeline Navigation */}
        <section className="fleet-timeline" ref={timelineRef}>
          <div className="timeline-track">
            <div className="timeline-line"></div>
            <div className="timeline-points">
              {fleetData.map((plane, index) => (
                <div
                  key={plane.id}
                  className={`timeline-point ${activePlaneIndex === index ? 'active' : ''}`}
                  onClick={() => setActivePlaneIndex(index)}
                >
                  <div className="point-circle"></div>
                  <span className="point-label">{plane.model}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Info Cards Grid */}
        <section className="fleet-info-cards">

          <div className="info-card animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s' }}>
            <div className="card-header">
              <div className="icon-box"><PlaneIcon /></div>
              <div className="card-title-group">
                <span className="card-label">FLOTA</span>
                <span className="card-value">{currentPlane.fleetSize}</span>
              </div>
            </div>
            <div className="card-body-section">
              <span className="sub-label">CAPACIDAD MÁXIMA DE CARGA</span>
              <span className="sub-value">{currentPlane.maxCapacity}</span>
            </div>
          </div>

          <div className="info-card animate__animated animate__fadeInUp" style={{ animationDelay: '0.4s' }}>
            <div className="card-header">
              <div className="icon-box"><LocationIcon /></div>
              <div className="card-title-group">
                <span className="card-label">AUTONOMÍA</span>
                <span className="card-value">{currentPlane.autonomy}</span>
              </div>
            </div>
            <div className="card-body-section">
              <span className="sub-label">CATEGORÍA</span>
              <span className="sub-value">{currentPlane.category}</span>
            </div>
          </div>

          <div className="info-card animate__animated animate__fadeInUp" style={{ animationDelay: '0.6s' }}>
            <div className="card-header">
              <div className="icon-box"><BoxIcon /></div>
              <div className="card-title-group">
                <span className="card-label">DIMENSIONES MÁXIMAS</span>
              </div>
            </div>
            <div className="dimensions-grid">
              <div className="dim-item">
                <span className="dim-label">ALTO</span>
                <span className="dim-value">{currentPlane.dimensions.high}</span>
              </div>
              <div className="dim-item">
                <span className="dim-label">LARGO</span>
                <span className="dim-value">{currentPlane.dimensions.long}</span>
              </div>
              <div className="dim-item">
                <span className="dim-label">ANCHO</span>
                <span className="dim-value">{currentPlane.dimensions.width}</span>
              </div>
              <div className="dim-item">
                <span className="dim-label">PESO</span>
                <span className="dim-value">{currentPlane.dimensions.weight}</span>
              </div>
            </div>
          </div>

        </section>

      </main>

      <Footer />
    </div>

  );
}

export default Fleet;
